export default __webpack_public_path__ + "static/media/iconeExcel.e2e92617.svg";